import { observer } from "mobx-react-lite";
import { Step, store } from "../stores/Store";
import { Button } from "./Button";

import './BottomSummarySwatches.scss'
import { formatCurrency } from "../utils/Currency";
import { InfoIcon } from "../icons/InfoIcon";
import Collapse from "./Collapse";
import SampleCard from "./SampleCard";
import { useWindowSize } from "../effects/useWindowSize";
import { useScrollPosition } from "../effects/useScrollPosition";
import { AnimatePresence, motion, scale } from "motion/react";
import { _t } from '../utils/Lang';


const BottomSummarySwatches = observer(({ isOpen }) => {

    const windowSize = useWindowSize();
    const { scrollPosition, divRef } = useScrollPosition();

    const compactMode = windowSize.width < 768
    const swatchStore = store.selectedSwatches;



    const list = <div ref={divRef} className="BottomSummarySwatches__swatches-list d-flex g-1 ">
        <AnimatePresence>

            {swatchStore.selectedSwatches.map((item, index) => {
                return <motion.div
                    key={item.id}
                    ease="easeOut"
                    transition={{
                        ease: "linear",

                    }}

                    exit={{ opacity: 0, scale: .8 }}
                    initial={{ opacity: 0, scale: .8 }}
                    animate={{ opacity: 1, scale: 1 }}>

                    <SampleCard
                        onClick={async () => {
                            if (swatchStore.includes(item)) {
                                await swatchStore.removeSwatch(item);
                            } else {
                                await swatchStore.addSwatch(item);
                            }
                        }}
                        checked={swatchStore.includes(item)}
                        imageUrl={item.imageUrl}
                        name={item.name} className="cart" />
                </motion.div>
            })}
        </AnimatePresence>
    </div>

    return <>
        <div className={`BottomSummarySwatches ${compactMode ? 'BottomSummarySwatches--compact' : 'BottomSummarySwatches--no-compact'} ${isOpen ? 'BottomSummarySwatches--open' : ''}`}>
            <div className="row g-0">
                <div className="col col-12 col-md-7 col-xxl-8 d-none d-md-flex">
                    <div className="BottomSummarySwatches__swatches">
                        <div className="BottomSummarySwatches__label">
                            <div>{_t('your_samples')}</div>
                            {_t('in_cart')} ({swatchStore.amount}{_t('pieces')})

                        </div>
                        {list}
                        <button
                            onClick={() => {
                                if (divRef.current) {
                                    divRef.current.scrollBy({
                                        top: 0,
                                        left: divRef.current.clientWidth * 0.8,
                                        behavior: 'smooth'
                                    });
                                    console.log('scroll', divRef.current.clientWidth * 0.8);
                                }
                            }}
                            style={{
                                display: (!scrollPosition.hasScrollX || scrollPosition.isEndX) ? 'none' : 'block'
                            }}
                            className="BottomSummarySwatches__next">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" rx="12" fill="black" />
                                <path d="M19.1743 12.4243C19.4086 12.1899 19.4086 11.8101 19.1743 11.5757L15.3559 7.75736C15.1216 7.52305 14.7417 7.52305 14.5074 7.75736C14.273 7.99167 14.273 8.37157 14.5074 8.60589L17.9015 12L14.5074 15.3941C14.273 15.6284 14.273 16.0083 14.5074 16.2426C14.7417 16.477 15.1216 16.477 15.3559 16.2426L19.1743 12.4243ZM5.25 12V12.6L18.75 12.6V12V11.4L5.25 11.4V12Z" fill="white" />
                            </svg>

                        </button>
                    </div>


                </div>
                {
                    compactMode ? (
                        <div className="col col-12 col-md-5 col-xxl-4">

                            <Collapse
                                title={({ open }) => {
                                    return <>

                                        {_t('your_samples')} ({swatchStore.amount} {_t('pieces')}) {open ? _t('swatches_collapse') : _t('swatches_expand')} <svg className="Collapse__arrow" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.00056 6.99988L0.282227 1.28154L1.04473 0.519043L6.00056 5.47488L10.9564 0.519043L11.7189 1.28154L6.00056 6.99988Z" fill="#1F1F1F" />
                                        </svg>
                                    </>

                                }}
                                open={true} className="">
                                {list}
                            </Collapse>
                            <div className="BottomSummarySwatches__total">
                                {formatCurrency(swatchStore.totalPrice)} <span className="BottomSummarySwatches__total--small">/{formatCurrency(swatchStore.unitPrice)} {_t('piece')}</span>
                            </div>
                            <div className="BottomSummarySwatches__description">{_t('samples_in_cart')}</div>
                            <div className="BottomSummarySwatches__buttons">
                                <Button onClick={() => {
                                    window.location.assign('/basket');
                                }} className="btn primary hollow">{_t('go_to_cart')}</Button>
                                <Button onClick={() => {
                                    store.closeSwatches();
                                    store.closeSwatchesCategory();
                                }} className="btn primary">{_t('continue_shopping')}</Button>
                            </div>
                        </div>
                    ) : (
                        <div className="col col-12 col-md-5 col-xxl-4">
                            <div className="BottomSummarySwatches__total">
                                {formatCurrency(swatchStore.totalPrice)} <span className="BottomSummarySwatches__total--small">/{formatCurrency(swatchStore.unitPrice)} {_t('piece')}</span>
                            </div>
                            <div className="BottomSummarySwatches__description">{_t('samples_in_cart')}</div>
                            <div className="BottomSummarySwatches__buttons">
                                <Button onClick={() => {
                                    window.location.assign('/basket');
                                }} className="btn primary hollow">{_t('go_to_cart')}</Button>
                                <Button onClick={() => {
                                    store.closeSwatches();
                                    store.closeSwatchesCategory();
                                }} className="btn primary">{_t('continue_shopping')}</Button>
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    </>

})
BottomSummarySwatches.displayName = 'BottomSummarySwatches'
export default BottomSummarySwatches